/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountFull } from './AccountFull';
import {
    AccountFullFromJSON,
    AccountFullFromJSONTyped,
    AccountFullToJSON,
} from './AccountFull';

/**
 * 
 * @export
 * @interface UserAccountResponseFull
 */
export interface UserAccountResponseFull {
    /**
     * 
     * @type {AccountFull}
     * @memberof UserAccountResponseFull
     */
    data?: AccountFull;
}

/**
 * Check if a given object implements the UserAccountResponseFull interface.
 */
export function instanceOfUserAccountResponseFull(value: object): value is UserAccountResponseFull {
    let isInstance = true;

    return isInstance;
}

export function UserAccountResponseFullFromJSON(json: any): UserAccountResponseFull {
    return UserAccountResponseFullFromJSONTyped(json, false);
}

export function UserAccountResponseFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccountResponseFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : AccountFullFromJSON(json['data']),
    };
}

export function UserAccountResponseFullToJSON(value?: UserAccountResponseFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': AccountFullToJSON(value.data),
    };
}

